module.exports = __webpack_public_path__ + "avatar.png?b55c979a5c28a5ff60086bf3cff893bd";